import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { AddCircle as AddCircleIcon } from '@material-ui/icons';
import WalletModal from '../Modals/WalletModal';
import { listWallet, createWallet } from '../../services/WalletService';
import { notifySuccess, notifyError } from '../Messages/Notification';
import color from '../../assets/css/colors';

const useStyles = makeStyles(() => ({
  dropdownWrapper: {
    display: 'flex',
    position: 'relative',
  },
  actionWrapper: {
    position: 'absolute',
    top: 29,
    right: 20,
    padding: 8,
    backgroundColor: 'unset',
    borderRadius: 5,
    '& svg': {
      width: 24,
      height: 24,
      cursor: 'pointer',
      '& path': {
        fill: color.primary.main,
      },
    },
  },
}));

export default function SelectWallet(props) {
  const classes = useStyles();

  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const data = {
    walletId: '',
    symbol: '',
    accountNo: props.accountNo || '',
    accountId: props.accountId || 0,
    wallet: '',
    status: 'Pending Approval',
    note: '',
  };

  const getOptions = async (props) => {
    const { walletsList } = await listWallet(props);

    setOptions(walletsList);
  };

  React.useEffect(() => {
    let param = {
      accountNo: props.accountNo,
      status: 'Active',
    };

    getOptions(param);
  }, [props.accountNo]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = async (data) => {
    if (!data) {
      setOpen(false);
      return;
    }

    let valid = true;

    if (!data.status) {
      notifyError('Status is required.');
      valid = false;
    }

    if (!data.wallet) {
      notifyError('Wallet is required.');
      valid = false;
    }

    if (!valid) {
      return;
    }

    try {
      setLoading(true);

      await createWallet(data);

      notifySuccess('New Wallet has been added.');
    } catch (error) {
      setLoading(false);
      notifyError(error.message);
    } finally {
      setOpen(false);
      setLoading(false);
    }
  };

  return (
    <div className={classes.dropdownWrapper}>
      <FormControl
        fullWidth
        error={props.error}
        style={{
          marginTop: props.mt ? props.mt : 0,
          marginBottom: props.mb ? props.mb : 0,
        }}
        disabled={props.disabled}
      >
        <InputLabel
          className={props.disabled ? classes.disabled : ''}
          shrink
          required={props.required}
        >
          {props.label}
        </InputLabel>
        <Select
          displayEmpty
          fullWidth
          disabled={props.disabled}
          name={props.name}
          value={props.value ? props.value : ''}
          onChange={props.onChange}
        >
          <MenuItem key="blank" value="">
            <span style={{ color: '#bbbdc5' }}>{props.placeholder}</span>
          </MenuItem>
          {options.length ? (
            options.map((i) => (
              <MenuItem key={i.walletId} value={i.walletId}>
                {i.wallet} ({i.symbol})
              </MenuItem>
            ))
          ) : (
            <MenuItem key="" value=""></MenuItem>
          )}
        </Select>
      </FormControl>
      {props.allowAddWallet && (
        <div className={classes.actionWrapper}>
          <Tooltip arrow placement="top" title="Add Wallet">
            <IconButton aria-label="add" onClick={() => handleOpen()}>
              <AddCircleIcon color="primary" />
            </IconButton>
          </Tooltip>
        </div>
      )}
      <WalletModal open={open} close={handleClose} data={data} loading={loading} />
    </div>
  );
}
